<template>
    <div id="idea">
        <div class="idea-box">
            <img src="../../../assets/image/idea.jpg" alt="">
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
            
        }
    }
}
</script>
<style lang="scss" scoped>
    #idea{
        width: 100%;
        .idea-box{
            padding: 0 110px 30px 110px;
            img{
                width: 100%;
                height: 100%;
                margin-top: 20px;
            }
        }
    }
</style>